// A code entered at signup is held here until the user verifies their email,
// then bound (see useAuth). localStorage (not sessionStorage) so it survives
// the email-verification context switch: the user clicks the verify link in a
// browser and may close/reopen the desktop app before the post-verify sign-in.
// Cleared on bind success or a permanent rejection (see useAuth).
const KEY = 'scrivar_pending_code';

export function setPendingCode(code) {
  try { if (code) localStorage.setItem(KEY, code); else localStorage.removeItem(KEY); } catch { /* ignore */ }
}
export function getPendingCode() {
  try { return localStorage.getItem(KEY); } catch { return null; }
}
export function clearPendingCode() {
  try { localStorage.removeItem(KEY); } catch { /* ignore */ }
}
